var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#02A7E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3204 8.09305L5.39478 15.3519C4.85302 15.5713 4.87372 16.3163 5.42689 16.5075L8.50737 17.5725C9.47059 17.9055 10.541 17.7791 11.3918 17.2318L19.5995 11.9523C19.9251 11.7429 20.2843 12.1674 20.0049 12.4314L14.2053 17.9117C13.6975 18.3915 13.7726 19.1981 14.3609 19.5835L20.7714 23.7834C21.5545 24.2964 22.6262 23.8499 22.7726 22.9496L24.9848 9.34493C25.1312 8.44475 24.1935 7.73948 23.3204 8.09305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.1d793695fa37cbd941577daae36a9922.svg";
export { ForwardRef as ReactComponent };